import PrivacyConsentGroup from './PrivacyConsentGroup'
import { maskBirthday, maskCPF, maskPhone } from '~/design-system/helpers/utilsValidation'
import { Card } from '~/design-system/primitives'
import { Badge, CalendarMonth, Call, ContactMail, Subtitles } from '~/icons'
import { cn } from '~/lib/cn'
import type { Profile } from '~/type/User'
interface NaturalPersonDataProps {
  profile: Profile
}

export default function NaturalPersonData({ profile }: NaturalPersonDataProps) {
  return (
    <Card className={cn('flex flex-col lg:w-6/6 m-0 justify-center self-stretch')} color="primary">
      <Card className={cn('flex flex-row lg:w-6/6 m-0 p-0 justify-center self-stretch')}>
        <Card className={cn('flex flex-row items-baseline lg:w-6/6 p-0 self-stretch')}>
          <Badge />
          <Card className="flex flex-col gap-2 p-0">
            <span className="text-primary-black text-base font-medium">Nome</span>
            <span className="text-primary-black text-base">
              {profile.firstName} {profile.lastName}
            </span>
          </Card>
        </Card>
      </Card>
      <Card className={cn('flex flex-row lg:w-6/6 m-0 p-0 justify-center self-stretch')}>
        <Card className={cn('flex flex-row items-baseline lg:w-6/6 p-0 self-stretch')}>
          <ContactMail />
          <Card className="flex flex-col gap-2 p-0">
            <span className="text-primary-black text-base font-medium">Email</span>
            <span className="text-primary-black text-base">{profile.email}</span>
          </Card>
        </Card>
      </Card>
      <Card className={cn('flex flex-row lg:w-6/6 m-0 p-0 justify-center self-stretch')}>
        <Card className={cn('flex flex-row items-baseline lg:w-6/6 p-0 self-stretch')}>
          <Subtitles />
          <Card className="flex flex-col gap-2 p-0">
            <span className="text-primary-black text-base font-medium">CPF</span>
            <span className="text-primary-black text-base">{maskCPF(profile.document)}</span>
          </Card>
        </Card>
      </Card>
      <Card className={cn('flex flex-row lg:w-6/6 m-0 p-0 justify-center self-stretch')}>
        <Card className={cn('flex flex-row items-baseline lg:w-6/6 p-0 self-stretch')}>
          <Call />
          <Card className="flex flex-col gap-2 p-0">
            <span className="text-primary-black text-base font-medium">Telefone</span>
            <span className="text-primary-black text-base">{maskPhone(profile.phone)}</span>
          </Card>
        </Card>
      </Card>
      <Card className={cn('flex flex-row lg:w-6/6 m-0 p-0 justify-center self-stretch')}>
        <Card className={cn('flex flex-row items-baseline lg:w-6/6 p-0 self-stretch')}>
          <CalendarMonth />
          <Card className="flex flex-col gap-2 p-0">
            <span className="text-primary-black text-base font-medium">Data de nascimento</span>
            <span className="text-primary-black text-base">{maskBirthday(profile.dateOfBirth)}</span>
          </Card>
        </Card>
      </Card>
      <PrivacyConsentGroup
        disablePolicyCheckbox={true}
        disableSwift_vc={true}
        disableSwiftEvoceComunicacao={true}
        isCorporate={profile.isCorporate}
      />
    </Card>
  )
}
